export default "__VITE_ASSET__0agvaQJo__"